module.exports = __webpack_public_path__ + "static/media/canais-1.e308c443.jpg";